"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("./button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _withMobileDialog = _interopRequireDefault(require("@material-ui/core/withMobileDialog"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _component = _interopRequireDefault(require("./component"));

var _attach = _interopRequireDefault(require("./attach"));

var _collectionField = _interopRequireDefault(require("mson/lib/fields/collection-field"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FormDialog = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(FormDialog, _React$PureComponent);

  var _super = _createSuper(FormDialog);

  function FormDialog() {
    var _this;

    (0, _classCallCheck2.default)(this, FormDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      saveClicked: false,
      previousMode: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClose", function (withCancelButton) {
      // Prevent the user from losing data when pressing esc or clicking outside dialog
      var _this$props = _this.props,
          mode = _this$props.mode,
          onClose = _this$props.onClose,
          onCancel = _this$props.onCancel,
          currentForm = _this$props.currentForm;

      if (withCancelButton || mode !== 'update') {
        if (mode === 'update') {
          if (onCancel) {
            onCancel(currentForm);
          }
        } else {
          if (onClose) {
            onClose(currentForm);
          }
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEdit", function () {
      if (_this.props.onEdit) {
        _this.props.onEdit(_this.props.currentForm);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSave", function (event) {
      // Stop the form from refreshing the page
      event.preventDefault(); // Should the submit action be disabled? For example, we may be editing in a nested dialog

      if (!_this.props.disableSubmit) {
        if (_this.props.onSave) {
          _this.props.onSave();
        } // Disable the save button so that the user sees that something is being processed


        _this.setState({
          saveClicked: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDelete", function () {
      if (_this.props.onDelete) {
        _this.props.onDelete(_this.props.currentForm);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FormDialog, [{
    key: "isOpen",
    value: function isOpen() {
      var mode = this.props.mode;

      if (mode === _collectionField.default.MODES.DELETE || mode === _collectionField.default.MODES.RESTORE) {
        // Don't show the dialog when restoring
        return false;
      } else {
        return !!mode;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If the mode or err changes then allow the user to click save
      if (this.props.mode !== prevProps.mode || this.props.err !== prevProps.err) {
        this.setState({
          saveClicked: false
        });
      }

      if (this.props.mode !== prevProps.mode) {
        this.setState({
          previousMode: prevProps.mode
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          mode = _this$props2.mode,
          component = _this$props2.component,
          forbidUpdate = _this$props2.forbidUpdate,
          forbidDelete = _this$props2.forbidDelete,
          value = _this$props2.value,
          fullScreen = _this$props2.fullScreen;
      var _this$state = this.state,
          saveClicked = _this$state.saveClicked,
          previousMode = _this$state.previousMode;
      var disableSave = component.hasErrorForTouchedField() || !component.get('dirty') || saveClicked;
      var open = this.isOpen();
      var buttons = null; // Note: we analyze the previousMode so that the user isn't flashed with new buttons immediately
      // after they click save or close the dialog

      if (mode === 'update' || mode === 'create' || mode === null && (previousMode === 'update' || previousMode === 'create')) {
        buttons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
          type: "submit",
          label: "Save",
          icon: "Save",
          disabled: disableSave
        }), /*#__PURE__*/_react.default.createElement(_button.default, {
          label: "Cancel",
          icon: "Cancel",
          onClick: function onClick() {
            return _this2.handleClose(true);
          }
        }));
      } else if (!forbidUpdate || !forbidDelete) {
        buttons = /*#__PURE__*/_react.default.createElement("div", null, forbidUpdate ? '' : /*#__PURE__*/_react.default.createElement(_button.default, {
          label: "Edit",
          icon: "Edit",
          onClick: this.handleEdit
        }), forbidDelete ? '' : /*#__PURE__*/_react.default.createElement(_button.default, {
          label: value.archivedAt ? 'Restore' : 'Delete',
          icon: value.archivedAt ? 'Restore' : 'Delete',
          onClick: this.handleDelete
        }), /*#__PURE__*/_react.default.createElement(_button.default, {
          label: "Close",
          icon: "Cancel",
          onClick: function onClick() {
            return _this2.handleClose(true);
          }
        }));
      }

      return /*#__PURE__*/_react.default.createElement(_Dialog.default // fullScreen will be true on a small screen
      , {
        fullScreen: fullScreen,
        open: open,
        onClose: function onClose() {
          return _this2.handleClose(false);
        },
        "aria-labelledby": "form-dialog-title"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSave
      }, /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_component.default, {
        component: component,
        formTag: false,
        mode: mode
      })), buttons ? /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, buttons) : ''));
    }
  }]);
  return FormDialog;
}(_react.default.PureComponent);

FormDialog = (0, _withMobileDialog.default)()(FormDialog);
FormDialog = (0, _attach.default)(['err', 'dirty', 'value', 'mode', 'disableSubmit'])(FormDialog);
var _default = FormDialog;
exports.default = _default;